// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { PAGE_DETAILS_SECTION_CONSTANT } from '@client/app/components/pagedetails/details/sections/page-details-section.constant';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'page-details-dashboard-charts-policies',
    standalone: false,
    template: `
        <div class="row align-items-center">
            <div class="offset-4 col-18 page-dashboard-doughnut-container">
                <mon-chart-doughnut
                        *ngIf="!loading"
                        [labels]="labels"
                        [data]="data"
                        [options]="options"
                        [colors]="colors">
                </mon-chart-doughnut>
            </div>
            <div class="col-26 pl-0">
                <notification-change
                    [title]="'Policy violations' | translate"
                    (click)="onClickHandler.emit({params: {target: pageDetailsSectionPolicies}})"
                    [digit]="totalPolicyErrors">
                </notification-change>
                <ul class="list-inline mt-3 pl-4">
                    <li [ngbTooltip]="'Unwanted' | translate"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPolicies}})">
                        <span [ngClass]="{ 'text-danger': unwantedPolicyErrors > 0, 'text-grey': unwantedPolicyErrors <= 0}"
                              class="fas fa-ban fa-lg"></span>
                        {{ unwantedPolicyErrors | monNumber }}
                    </li>
                    <li [ngbTooltip]="'Required' | translate"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPolicies}})">
                        <span [ngClass]="{ 'text-orange': requiredPolicyErrors > 0, 'text-grey': requiredPolicyErrors <= 0}"
                              class="fas fa-exclamation-triangle fa-lg"></span>
                        {{ requiredPolicyErrors | monNumber }}
                    </li>
                    <li [ngbTooltip]="'Search' | translate"
                        [triggers]="'focus hover'"
                        (click)="onClickHandler.emit({params: {target: pageDetailsSectionPolicies}})">
                        <span [ngClass]="{ 'text-info': searchPolicyErrors > 0, 'text-grey': searchPolicyErrors <= 0}"
                              class="fas fa-search fa-lg"></span>
                        {{ searchPolicyErrors | monNumber }}
                    </li>
                </ul>
            </div>
        </div>
    `,
})
export class PageDetailsDashboardChartsPoliciesComponent implements OnInit {
    @Input() page: any;
    @Output() onClickHandler = new EventEmitter<any>();

    unwantedPolicyErrors = 0;
    requiredPolicyErrors = 0;
    searchPolicyErrors = 0;
    options: any = {};
    colors = ['#4dc0bd', '#dcdcdc'];
    data: any[] = [];
    labels = ['', ''];
    pageDetailsSectionPolicies = PAGE_DETAILS_SECTION_CONSTANT.POLICIES;
    loading = true;
    totalPolicyErrors = 0;
    percentage = 0;
    total = 0;

    constructor (
        private policyRepoService: PolicyRepoService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        this.unwantedPolicyErrors = this.page.policy_violation_count || 0;
        this.requiredPolicyErrors = this.page.policy_required_count || 0;
        this.searchPolicyErrors = this.page.policy_search_count || 0;
        this.options = {};
        this.colors = ['#4dc0bd', '#dcdcdc'];
        this.data = [];
        this.labels = ['', ''];
        this.pageDetailsSectionPolicies = PAGE_DETAILS_SECTION_CONSTANT.POLICIES;

        this.loading = true;
        this.getPolicyDomain().then((values) => {
            this.setupDoughnut(values);
        }, () => {
            // Handle error silently like the original
        }).finally(() => {
            this.loading = false;
        });
    }

    private setupDoughnut (policies: any): void {
        const totalPolicies = parseInt(policies.total);
        this.totalPolicyErrors = this.unwantedPolicyErrors + this.requiredPolicyErrors + this.searchPolicyErrors;
        this.total = 0;

        if (totalPolicies > 0) {
            this.percentage = (this.totalPolicyErrors / totalPolicies) * 100;
            this.data = [totalPolicies - this.totalPolicyErrors, this.totalPolicyErrors];
        } else {
            this.percentage = 0;
            this.data = [1, 0];
        }

        const monNumberPipe = this.pipeService.get('monNumber');

        this.options = {
            centerText: {
                percentageLabel: monNumberPipe((100 - this.percentage) / 100, '0.[00] %'),
            },
            cutoutPercentage: 80,
            tooltips: {
                enabled: totalPolicies > 0,
                callbacks: {
                    beforeLabel: (tooltipItem: any, data: any) => {
                        return '';
                    },
                    label: (tooltipItem: any, data: any) => {
                        return monNumberPipe(
                            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                            '0,0',
                        );
                    },
                },
            },
        };
    }

    private getPolicyDomain (): Promise<any> {
        return this.policyRepoService.domainGetAll({ page: 1, page_size: 1 });
    }
}
